import { useState, useEffect } from 'react';
import API from '@/lib/api';
import { ShoppingCart, CheckCircle, Circle } from 'lucide-react';

export default function GroceryList() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [checked, setChecked] = useState({});

  useEffect(() => {
    API.get('/grocery-list').then(r => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const toggleCheck = (name) => setChecked(c => ({ ...c, [name]: !c[name] }));

  if (loading) return <div className="flex justify-center py-20"><div className="w-8 h-8 border-2 border-[#E05A47] border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div className="fade-in space-y-6" data-testid="grocery-list-page">
      <div>
        <h1 className="text-3xl font-extrabold tracking-tight text-[#222] font-[Manrope]">Grocery List</h1>
        <p className="mt-2 text-[#717171]">Auto-generated from your active bookings and events</p>
      </div>

      {/* Sources Summary */}
      {data?.sources && (
        <div className="grid grid-cols-3 gap-4">
          <div className="bg-[#F7F7F7] rounded-xl p-4 text-center" data-testid="source-meal-plans">
            <p className="text-2xl font-extrabold text-[#222] font-[Manrope]">{data.sources.active_meal_plans}</p>
            <p className="text-xs text-[#717171] font-medium mt-1">Active Meal Plans</p>
          </div>
          <div className="bg-[#F7F7F7] rounded-xl p-4 text-center" data-testid="source-events">
            <p className="text-2xl font-extrabold text-[#222] font-[Manrope]">{data.sources.upcoming_events}</p>
            <p className="text-xs text-[#717171] font-medium mt-1">Upcoming Events</p>
          </div>
          <div className="bg-[#F7F7F7] rounded-xl p-4 text-center" data-testid="source-bookings">
            <p className="text-2xl font-extrabold text-[#222] font-[Manrope]">{data.sources.approved_bookings}</p>
            <p className="text-xs text-[#717171] font-medium mt-1">Approved Bookings</p>
          </div>
        </div>
      )}

      <div className="bg-white rounded-2xl border border-[#EBEBEB] overflow-hidden">
        <div className="p-4 border-b border-[#EBEBEB] flex items-center justify-between">
          <div className="flex items-center gap-2">
            <ShoppingCart className="w-5 h-5 text-[#E05A47]" strokeWidth={1.5} />
            <span className="font-bold text-[#222] font-[Manrope]">{data?.total_items || 0} Items</span>
          </div>
          <span className="text-xs text-[#717171]">{Object.values(checked).filter(Boolean).length} checked</span>
        </div>
        {data?.items?.length === 0 ? (
          <div className="p-8 text-center text-[#717171]">No items to show. Create bookings or events to generate the list.</div>
        ) : (
          <div className="divide-y divide-[#EBEBEB]">
            {data?.items?.map(item => (
              <button
                key={item.name}
                onClick={() => toggleCheck(item.name)}
                className="w-full flex items-center gap-3 px-4 py-3 hover:bg-[#F7F7F7] transition-colors text-left"
                data-testid={`grocery-item-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {checked[item.name] ? (
                  <CheckCircle className="w-5 h-5 text-[#008A05] flex-shrink-0" strokeWidth={1.5} />
                ) : (
                  <Circle className="w-5 h-5 text-[#EBEBEB] flex-shrink-0" strokeWidth={1.5} />
                )}
                <span className={`flex-1 text-sm font-medium ${checked[item.name] ? 'line-through text-[#717171]' : 'text-[#222]'}`}>{item.name}</span>
                <span className="text-xs text-[#717171]">{item.quantity} {item.unit}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
